var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 4.82812H10C7.8 4.82812 6 6.62812 6 8.82812V36.8281C6 39.0281 7.8 40.8281 10 40.8281H38C40.2 40.8281 42 39.0281 42 36.8281V8.82812C42 6.62812 40.2 4.82812 38 4.82812ZM14 12.8281H18V16.8281H14V12.8281ZM14 20.8281H18V24.8281H14V20.8281ZM14 28.8281H18V32.8281H14V28.8281ZM34 32.8281H22V28.8281H34V32.8281ZM34 24.8281H22V20.8281H34V24.8281ZM34 16.8281H22V12.8281H34V16.8281Z",
    fill: "#007696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.f8879734231650e5795867e3d0656c53.svg";
export { ForwardRef as ReactComponent };